/** Strict API check — only true when backend explicitly sets is_contacted. */
export function isContactedFromApi(item) {
  if (!item || typeof item !== "object") return false;

  const candidates = [
    item.is_contacted,
    item.isContacted,
    item.raw?.is_contacted,
    item.project?.is_contacted,
    item.details?.is_contacted,
  ];

  return candidates.some((v) => v === true);
}

/** Resolve project id from listing/detail card shapes. */
export function getProjectId(item) {
  if (!item || typeof item !== "object") return null;
  const id =
    item.id ??
    item.project_id ??
    item.projectId ??
    item.raw?.id ??
    item.raw?.project_id ??
    item.project?.id ??
    item.project?.project_id ??
    null;
  if (id == null || id === "") return null;
  return String(id).trim();
}

/** Merge API flag with optimistic override set (session-only). */
export function resolveIsContacted(item, contactedOverrideIds) {
  if (isContactedFromApi(item)) return true;
  const id = getProjectId(item);
  if (!id || !contactedOverrideIds) return false;
  return contactedOverrideIds.has(id);
}
